import { render } from "./LabelApproveDialog.vue?vue&type=template&id=6dad55e6"
import script from "./LabelApproveDialog.vue?vue&type=script&lang=js"
export * from "./LabelApproveDialog.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__